import setFusoHorarioListener from './SetFusoHorarioListener'
import registerGlobalComponentsListener from './RegisterGlobalComponentsListener'
import interceptadorHttp from './InterceptadorHttp'
import keycloakListener from './KeycloakListener'

export default {
    setFusoHorarioListener,
    registerGlobalComponentsListener,
    interceptadorHttp,
    keycloakListener
}
